import LoadEvent from '@/brain/item-association/LoadEvent'
import NavigateMap from '@/brain/item-association/NavigateMap'
import QuoteItem from '@/brain/item-association/QuoteItem'
import UnquoteItem from '@/brain/item-association/UnquoteItem'
import EditItemData from '@/brain/item-association/EditItemData'

const state = {
  actualPage: 0,
  offsetPage: 10,
  list: [],
  searchingAccumulatorStatus: 0,
  selectedItem: {
    quote: {
      message: []
    }
  },
  filterMap: ['ALL', 0, 1, 'MESSAGE'],
  quoteConfig: {
    cleanSearchAfterQuote: true,
    jumpToNextItemWhenQuote: false,
    sortOrder: '{ "isPreferred": -1, "lastBuyingDate": -1, "stockQuantity": -1, "cost": -1 }',
    filterOnlyWithStock: false
  },
  searchTip: null
}

const getters = {
  GET_ALL_CONFIG: state => state.quoteConfig,
  GET_CONFIG: state => indexConfig => state.quoteConfig[indexConfig],
  GET_ALL_LIST: (state) => state.list,
  GET_ITEM_SELECTED_ID: (state) => state.selectedItem ? state.selectedItem._id : null,
  GET_ITEM_SELECTED_DETAILS: (state) => state.selectedItem ? { _id: state.selectedItem._id, ...state.selectedItem.itemInfo } : null,
  GET_ITEM_QUOTED_DETAILS: (state) => state.selectedItem || {},
  COUNT_TOTAL_ITEMS: (state) => state.list.length,
  COUNT_QUOTED_ITEMS: (state) => state.list.filter((item) => item.quote && item.quote.item).length,
  COUNT_UNQUOTED_ITEMS: (state, getters) => getters.COUNT_TOTAL_ITEMS - getters.COUNT_QUOTED_ITEMS,
  COUNT_ALERT_ITEMS: (state) => state.list.filter((item) => item.quote && item.quote.message && item.quote.message.length > 0).length,
  GET_FILTER_MAP: (state) => state.filterMap,
  GET_MAPPED_LIST: (state) => {
    const list = [...state.list]
    let mapped = []
    mapped = list.map((item) => {
      return {
        id: item._id,
        lot: item.itemInfo.lot || 'N',
        number: item.itemInfo.number,
        status: item.status,
        message: item.quote ? item.quote.message : null,
        strictToME: item.itemInfo.strictToME
      }
    })
    if (!state.filterMap.includes('ALL')) {
      mapped = mapped.filter((item) => {
        const status = state.filterMap.includes(item.status)
        const msg = state.filterMap.includes('MESSAGE') && item.message && item.message.length > 0
        return status || msg
      })
    }
    return mapped
  },
  HAVE_REVISION: (state) => state.selectedItem && state.selectedItem.quote && state.selectedItem.quote.message && state.selectedItem.quote.message.length > 0,
  GET_SEARCH_STATUS: (state) => state.searchingAccumulatorStatus,
  GET_SEARCH_TIP: (state) => state.searchTip
}

const mutations = {
  SET_LIST_ITEMS: (state, { listItems }) => { state.list = listItems },
  SET_SELECTED_ITEM: (state, { itemDetail }) => { state.selectedItem = itemDetail },
  SET_FILTER_BY: (state, filterMap) => { state.filterMap = filterMap },
  UPDATE_ITEM: (state, { itemIndex, itemData }) => {
    const newList = [...state.list]
    newList[itemIndex] = itemData
    state.list = newList
  },
  FILL_MESSAGE: (state) => { state.selectedItem.quote.message.push({ status: true }) },
  CHANGE_CONFIGURATION: (state, configs) => { state.quoteConfig = configs },
  SEARCH_INCREASE_STATUS: (state) => { state.searchingAccumulatorStatus++ },
  SEARCH_DECREASE_STATUS: (state) => { state.searchingAccumulatorStatus-- },
  ERASE_STATUS_ACCUMULATOR: (state) => { state.searchingAccumulatorStatus = 0 },
  UPDATE_EDITED_ITEM: (state, { itemId = null, infoData }) => {
    let editedItem = {}
    for (let item in state.list) {
      if (state.list[item]._id !== itemId) continue
      editedItem = Object.assign({}, state.list[item].itemInfo, infoData)
      state.list[item].itemInfo = editedItem
      break
    }
  },
  SET_SEARCH_TIP: (state, searchTip) => { state.searchTip = searchTip.trim() }
}

const actions = {
  LOAD_EVENT: LoadEvent,
  NAVIGATE_MAP: NavigateMap,
  QUOTE_ITEM: QuoteItem,
  UNQUOTE_ITEM: UnquoteItem,
  UPDATE_ITEM_DATA: EditItemData
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/view/item-association/state/index.js